import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import API from "@beardeddevops/react.api";

/**
 *  @property {Kpi_Metrics_Object} state
 *  @property {object} model
 *  @property {Kpi_Metrics_Properties} model.properties
 *  @property {Kpi_Metrics_Is} model.is
 *  @property {Kpi_Metrics_Has} model.has
 */

export default class KpiMetric extends Framework.Components.Object {
	constructor(props) {

		super(props, Types.Kpi_Metrics._name);
	}


	form = () => {

		/**
		 * @param {Kpi_Metrics_Properties} data
		 */
		let {properties} = this.model
		/**
		 * @type {Kpi_Metrics_Object} object
		 */
		let object = this.state

		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={"col-4"}>
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.hourly}
									value={object.hourly}
									error={object.hourly_error}
									update={this.handleTextFieldPropertyUpdate}
									label={'Hourly Limit (Daily for Hiring)'}
								/>
							</div>
						</div>
						<div className={"col-4"}>
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.daily}
									value={object.daily}
									error={object.daily_error}
									update={this.handleTextFieldPropertyUpdate}
									label={'Daily Limit (Weekly for Hiring)'}
								/>
							</div>
						</div>
						<div className={"col-4"}>
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.multiplier}
									value={object.multiplier}
									error={object.multiplier_error}
									update={this.handleTextFieldPropertyUpdate}
									label={'Optional Multiplier'}
								/>
							</div>
						</div>
					</div>
				</fieldset>
				<Framework.Elements.LoadingSpinner isLoading={loading}/></div>

		)
	}
}
